const decision = {
  state: {
    currentPath: '',
    homeItem: [],
    lastActive: 0,
    refreshing: false,
    currentObj: undefined
  },
  mutations: {
    CHANGE_CURRENTPATH: (state, path) => {
      state.currentPath = path
    },
    SET_HOME_ITEM: (state, list) => {
      if (list && list.length > 0) {
        state.lastActive = list[0]
        state.homeItem = list
      }
    },
    SET_LAST_ACTIVE: (state, id) => {
      state.lastActive = id
    },
    SET_DECISION_REFRESH_STATUS: (state, status) => {
      state.refreshing = status || false
    },
    SET_CURRENT_OBJ: (state, obj) => {
      state.currentObj = obj
    }
  },
  actions: {
    ChangeCurrentPath({ commit }, path) {
      commit('CHANGE_CURRENTPATH', path)
    },
    setDecisionInHome({ commit }, decisionList) {
      commit('SET_HOME_ITEM', decisionList)
    },
    setLastActiveDecision({ commit }, decisionId) {
      commit('SET_LAST_ACTIVE', decisionId)
    },
    setDecisionRefreshStatus({ commit }, status) {
      commit('SET_DECISION_REFRESH_STATUS', status)
    },
    openDecision({ commit, state }, decisionInfo) {
      if (state.homeItem.indexOf(+decisionInfo.decisionId) >= 0) {
        // 在首页按钮中
        commit('SET_LAST_ACTIVE', decisionInfo.decisionId)
        decisionInfo.vm.$router.push('/dashboard')
      } else {
        // 不在首页按钮中
        const routerTemp = {
          name: decisionInfo.decisionName,
          decisionId: decisionInfo.decisionId,
          path: `/dashboard/${decisionInfo.decisionId}`
        }
        decisionInfo.vm.$router.push(routerTemp.path)
        this.dispatch('SetLastTab', routerTemp)
        this.dispatch('addView', routerTemp)
        // decisionInfo.vm.$nextTick(() => {
        //   // this.$refs.activeView.showDecision(decisionInfo.decisionId)
        //   debugger
        // })
      }
    },
    setCurrentObj({ commit }, obj) {
      commit('SET_CURRENT_OBJ', obj)
    }
  }
}
export default decision
